export interface RoiWorkViewProps {
  projectId?: string;
  onBack?: () => void;
}

export type EditMode = 'create' | 'update' | 'delete' | null;

export const DRAWER_WIDTH = 260;
export const RIGHT_DRAWER_WIDTH = 300;
